import { useEffect, useState } from 'react';

interface SolutionRichDetailModalProps {
  open: boolean;
  title: string;
  subtitle?: string;
  html: string;
  accentClass?: string;
  onClose: () => void;
}

export default function SolutionRichDetailModal({
  open,
  title,
  subtitle,
  html,
  accentClass = 'text-[#0ea5e9]',
  onClose,
}: SolutionRichDetailModalProps) {
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    if (!open) {
      setFullscreen(false);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 z-[120] flex ${fullscreen ? 'p-0' : 'p-4'} bg-black/70`}
      onClick={onClose}
    >
      <div
        className={`bg-white flex flex-col overflow-hidden shadow-2xl transition-all duration-200 min-w-0 ${
          fullscreen
            ? 'w-full h-full rounded-none'
            : 'w-full max-w-3xl h-[min(80vh,720px)] rounded-2xl my-auto mx-auto'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 shrink-0">
          <div className="min-w-0 pr-4">
            <h3 className={`font-semibold text-gray-900 text-sm truncate ${accentClass}`}>{title}</h3>
            {subtitle ? <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p> : null}
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <button
              type="button"
              onClick={() => setFullscreen((prev) => !prev)}
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
              title={fullscreen ? '退出全屏' : '全屏查看'}
              aria-label={fullscreen ? '退出全屏' : '全屏查看'}
            >
              <i className={`${fullscreen ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'} text-gray-500`}></i>
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
              title="关闭"
              aria-label="关闭"
            >
              <i className="ri-close-line text-gray-500"></i>
            </button>
          </div>
        </div>
        <div className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden px-5 py-4 bg-[#f8fafc]">
          <div
            className="rich-text-editor__preview min-w-0 max-w-full bg-white rounded-xl border border-gray-100 p-4"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </div>
  );
}
